import {EventEmitter, Injectable} from '@angular/core';
import {WebStorageService} from './web-storage.service';

// Must stay free of HttpClient dependencies: HTTP interceptors end the session on 401,
// and anything reaching back to HttpClient from here closes a dependency injection cycle.
@Injectable({
  providedIn: 'root'
})
export class SessionService {
  public onEnded: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    private readonly storageService: WebStorageService
  ) {
  }

  public end(): void {
    this.storageService.deleteItem('token');
    this.storageService.deleteItem('organizationId');

    this.onEnded.emit();
  }
}
